(function($){

	/* Get accurate Viewport sizing (no jQuery) */
    var viewportwidth;
    var viewportheight;

    function getWindowSize(){
        if (typeof window.innerWidth != 'undefined'){
            viewportwidth = window.innerWidth,
            viewportheight = window.innerHeight
        }else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0){
            viewportwidth = document.documentElement.clientWidth,
            viewportheight = document.documentElement.clientHeight
        }else{
            viewportwidth = document.getElementsByTagName('body')[0].clientWidth,
            viewportheight = document.getElementsByTagName('body')[0].clientHeight
        }
    }

    
    function initSlider() {
        $('.slider--homepage').slick({
            dots: false,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true,
        });
        $('.slider--location').slick({
            dots: true,
            arrows: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true,
        });
        $('.slider--sidebar').slick({
            dots: true,
            arrows: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true,
        });
        $('.article-slider').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true,
        });
    }

    function providerPopup(){

        $('#provider__primary-care--trigger').sidr({
            side: 'right',
            name: 'provider__primary-care',
            displace: false,
            onOpen: function() {
                //alert('test');
                $('#provider__primary-care').addClass( 'active' );
            },
            onClose: function(){
                $('#provider__primary-care').removeClass( 'active' );
            }
        });
        $('#provider__specialist--trigger').sidr({
            side: 'right',
            name: 'provider__specialist',
            displace: false,
            onOpen: function() {
                //alert('test');
                $('#provider__specialist').addClass( 'active' );
            },
            onClose: function(){
                $('#provider__specialist').removeClass( 'active' );
            }
        });
        $('#provider__name--trigger').sidr({
            side: 'right',
            name: 'provider__name',
            displace: false,
            onOpen: function() {
                //alert('test');
                $('#provider__name').addClass( 'active' );
            },
            onClose: function(){
                $('#provider__name').removeClass( 'active' );
            }
        });
        $('#provider__location--trigger').sidr({
            side: 'right',
            name: 'provider__location',
            displace: false,
            onOpen: function() {
                //alert('test');
                $('#provider__location').addClass( 'active' );
            },
            onClose: function(){
                $('#provider__location').removeClass( 'active' );
            }
        });

        $('#provider__search--trigger').sidr({
            side: 'right',
            name: 'provider__search',
            displace: false,
            onOpen: function() {
                //alert('test');
                $('#provider__search').addClass( 'active' );
            },
            onClose: function(){
                $('#provider__search').removeClass( 'active' );
            }
        });

        $('.sidr__close--provider').click(function() {
            var closeTrigger = $(this).attr("data-trigger");
            $.sidr('close', closeTrigger,);
        });


    }

    function searchFilter(){

        $('#search_filters').find('span').each(function(i){
            $(this).click(function(){
                var inputLabel = $(this).data('label');
                //alert('Emptying ' + inputLabel);
                
                $('[name$='+inputLabel+']').val('');
                $("#search_result_filter").submit();
            });
        });
    }


    /*
     *
     * Equal Height jQuery Snippet.  Using this for footer and grid accordion
     *
     */
    var equalheight = function (container){

        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = [],
            $el,
            topPosition = 0,
            currentDiv;
    
        $(container).each(function () {

            $el = $(this);
            $el.height('auto');
            topPosition = $el.position().top;

            if (currentRowStart < topPosition - 1 || currentRowStart > topPosition + 1) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs = [];
                currentRowStart = topPosition;
                currentTallest = $el.height();
                rowDivs.push($el);
            }
            else {
                rowDivs.push($el);
                currentTallest = Math.max(currentTallest, $el.height());
            }
        });
        
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].css('height', currentTallest);
        }
    };


    /* YOUTUBE VIDEO EMBED */
    var $video_icon = $('.video_icon');
    if ($video_icon.length) {
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        $video_icon.on("click", function() {
            var $this = $(this),
                $youtube_id = $(this).data('youtubeid'),
                $video_id = $(this).data('videoid'),
                $parent = $(this).parents('.video_parent'),
                $video_content = $('.video--content');
            $video_content.fadeOut(300);
            $this.fadeOut(300);
            player = new YT.Player($video_id, {
                videoId: $youtube_id,
                height: $parent.outerHeight(),
                width: $parent.outerWidth(),
                playerVars: {rel: 0},
                events: {
                    'onReady' : onPlayerReady
                }
            });

        });
    }

    function onPlayerReady(event) {
        event.target.playVideo();
    }
        
    function appendTestimonialNav(){
        var testimonial_sidebar = $('.testimonial_sidebar');
        var testimonial_sidebarWrapper = $('#testimonial_providers');
        var testimonial_singleContent = $('#testimonial');
        
        if(testimonial_singleContent.length){
            
            if(viewportwidth < 1024){
                //alert('small');
                testimonial_sidebar.appendTo(testimonial_singleContent).addClass('mt__3 mobile');
                testimonial_sidebarWrapper.hide();
                
            }else{
                testimonial_sidebar.prependTo(testimonial_sidebarWrapper).removeClass('mt__3 mobile');
                testimonial_sidebarWrapper.show();
            }
        }
    }
        
    function toggleSideNav(){
        if($('.sidebar-navigation').length){
            $('.has_children .arrow').click(function(e) {
                e.preventDefault();
                $(this).next().slideToggle();
                $(this).parent('.has_children').toggleClass('active');
            });
        }
    }
        
    function appendSidenav(){

        var singleContent = $('#single-content');
        var sidebarContactWrapper = $('#sidebar_contact--wrapper');
        var sidebarContact = $('#sidebar_contact');

        if(singleContent.length){
            if(viewportwidth < 1024){
                if(sidebarContact.length){
                    sidebarContact.addClass('mobile').appendTo(singleContent);
                }
            }else{
                if(sidebarContact.length){
                    sidebarContact.removeClass('mobile').appendTo(sidebarContactWrapper);
                }
            }
        }
    }
        
	/* Document Ready */
	$(document).ready(function() {
		getWindowSize();
        //equalheight('.equal-height');
        $('.equal-height').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
        
        $(".loader").fadeOut("fast");

        initSlider();
        providerPopup();
        searchFilter();
        appendSidenav();
        toggleSideNav();
        appendTestimonialNav();

        //Sidr
        $('#main_menu--trigger').sidr({
            side: 'right',
            name: 'main_menu',
            displace: false,
            onOpen: function() {
                //alert('test');
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
            },
            onOpenEnd: function(){
                $( 'body' ).css({
                    "position": "fixed",
                    "left": "0",
                    "top": "0",
                    "width": "100%"
                });
                $('.sidr-overlay').click(function() {
                    $.sidr('close','main_menu');
                });
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
            },
            onCloseEnd: function(){
                $( 'body' ).css({
                    "position": "relative",
                    "left": "auto",
                    "top": "auto",
                    "width": "100%"
                });
            }
        });
        $('.menu-item-has-children .arrow').click(function(e) {
            e.preventDefault();
            $(this).next().slideToggle();
        });
        $('.sidr__close').click(function() {
            $.sidr('close','main_menu');
        });
        
        $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,

            fixedContentPos: false
        });
        
        if($('#js-mobilesidebar').length){
            $('.js-sidebar-toggle').click(function(){
                $(this).toggleClass('active');
                $('.js-sidebar').toggle();
            });
        }
        
        $('.resource__filters--toggle').click(function(){
            $(this).toggleClass('active');
            $('.resource__filters').slideToggle();
        });
        
        $('.accordion').find('.accordion--title').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).next().slideToggle('fast');
        });
        
        $('.contact_toggle').on('click', function(e) {
            $('#contact_flex').slideToggle('slow');
        });
        

        //Location Dropdown Selector
        $('#loc_spec_selector').click(function(){
            $('#loc_spec_list').toggle();
        });

        $('#loc_spec_list a').click(function(event){
            event.preventDefault();
            var title = $(this).data('title');

            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 800);
            //alert(title);
            $("#loc_spec_selector span").html(title);
            $(this).parent('#loc_spec_list').hide();
        });
        
        
        //Location Dropdown Selector
        if($('.career__block').length){
            $('.career__block').hide();
            $('#car_spec_selector').click(function(){
                $('#car_spec_list').toggle();
            });

            $('#car_spec_list a').click(function(event){
                event.preventDefault();
                var title = $(this).data('title');
                $('.career__block').hide();
                
                $($.attr(this, 'href')).show();
                $('html, body').animate({
                    scrollTop: $($.attr(this, 'href')).offset().top
                }, 800);
                //alert(title);
                $("#car_spec_selector span").html(title);
                $(this).parent('#car_spec_list').hide();
            });
        }

        //Tabs on specialty page
        if($('.specialty__tabs').length){
            
            var firstTab;
            
            if(Cookies.get('tab-holder')) {
                //alert('cookie is set');
                firstTab = Cookies.get('tab-holder');
                
            }else{
                //alert('cookie is NOT set');
                firstTab = $('.tab-links .tab-link').first().attr('data-tab');
                Cookies.set('tab-holder', firstTab, { path: '' });
            }
            $('.specialty__tabs .tab-link[data-tab = '+firstTab+']').addClass('current');
            $('.specialty__tabs .tab-content#'+firstTab).addClass('current');
            $('.specialty__tabs .tab-link--mobile[data-mobile-tab = '+firstTab+']').addClass('current');

            //equalheight('.equal-height');
            $('.equal-height').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });

            
            $('.specialty__tabs .tab-link').click(function(){
                var tab_id = $(this).attr('data-tab');

                $('.specialty__tabs .tab-link').removeClass('current');
                $('.specialty__tabs .tab-content').removeClass('current');
                $('.specialty__tabs .tab-link--mobile').removeClass('current');

                $(this).addClass('current');
                $(".specialty__tabs").find("[data-mobile-tab='" + tab_id + "']").addClass('current');
                $("#"+tab_id).addClass('current');
                
                Cookies.get('tab-holder'); // => 'value'
                Cookies.set('tab-holder', tab_id, { path: '' });
                
                //equalheight('.equal-height');
                $('.equal-height').matchHeight({
                    byRow: true,
                    property: 'height',
                    target: null,
                    remove: false
                });
            });
            $('.specialty__tabs .tab-link--mobile').click(function(){
                var tab_id = $(this).attr('data-mobile-tab');
                
                if($(this).hasClass('current')){
                    $(this).toggleClass('collapsed');
                    $(".specialty__tabs").find("[data-tab='" + tab_id + "']").toggleClass('collapsed');
                    $("#"+tab_id).toggleClass('collapsed');
                }else{
                    $('.specialty__tabs .tab-link').removeClass('current collapsed');
                    $('.specialty__tabs .tab-link--mobile').removeClass('current collapsed');
                    $('.specialty__tabs .tab-content').removeClass('current collapsed');
                    
                    $(this).addClass('current');
                    $(".specialty__tabs").find("[data-tab='" + tab_id + "']").addClass('current');
                    $("#"+tab_id).addClass('current');

                    Cookies.get('tab-holder'); // => 'value'
                    Cookies.set('tab-holder', tab_id, { path: '' });

                    //equalheight('.equal-height');
                    $('.equal-height').matchHeight({
                        byRow: true,
                        property: 'height',
                        target: null,
                        remove: false
                    });
                }
            });
            //$('.specialty__tabs .tab-link--mobile.current').click(function(){
                /*var tab_id = $(this).attr('data-mobile-tab');
                
                if($(this).hasClass('collapsed')){
                    $(this).removeClass('collapsed');
                    $("#"+tab_id).removeClass('collapsed');
                }else{
                    $(this).addClass('collapsed');
                    $("#"+tab_id).addClass('collapsed');
                    
                }
                equalheight('.equal-height');*/
                
                /*$(this).addClass('collapsed');
                $(".specialty__tabs").find("[data-tab='" + tab_id + "']").addClass('collapsed');
                $("#"+tab_id).addClass('collapsed');*/
                
                
                /*if($(this).not('current').not('collapsed')){
                    $(this).removeClass('collapsed');
                    $("#"+tab_id).removeClass('collapsed');
                }else{
                    $(this).addClass('collapsed');
                    $("#"+tab_id).addClass('collapsed');
                }*/
            //});
        }

        $('#specialty_search').find('a').each(function(i){
            $(this).click(function(e){
                e.preventDefault();
                //alert($(this).text());

                $('#specialty_search #specialties').val($(this).attr('id'));
                $("#specialty_search").submit();
            });
        });
        
        ////// MYCHART PROVIDER BIOS JS ////// 

        //IF PAGE IS VIEWED THROUGH IFRAME			
        if (window.location !== window.parent.location) {

            // IF PARENT PAGE URL CONTAINS "mychart"
            if (document.referrer.indexOf("mychart") > -1) {

                //ADD CLASS TO BODY
                $("body").addClass("mychart-widget");

                //SELECT EACH A TAG
                $("body a").each(function () {

                    // STORE LINK HREF			
                    var href = $(this).attr("href");

                    // MAKE EACH A TAG USE _BLANK
                    $(this).attr("target", "_blank");

                    // MAKE EACH A TAG USE TRACKABLE URL PARAM FOR WEBSITE
                    $(this).attr("href", href + "?ref=mychart-bio");

                });
            }

        } else {

        }

    });
        
    var resizeId;
	$(window).on("resize", function() {
		getWindowSize();
        //equalheight('.equal-height');
        $('.equal-height').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
        appendSidenav();
        /*clearTimeout(resizeId);
        resizeId = setTimeout(appendSidenav, 200);*/
        appendTestimonialNav();

        if($('body').hasClass('sidr-open') && $(window).width() >= 1024) {
            $.sidr('close');
        }

	});
        
    $(window).load(function(e) {
        //$(".loader").fadeOut("fast");
        
        // scrollTo if #_ found
        var target = window.location.hash,
        target = target.replace('#', '');
        var $target = $('#' + target);
        //console.log(target);
    
        var pattern = /specialty/;
        var specialtyUrl = pattern.test(target);

        if (specialtyUrl) {
            //window.location.hash = '';
            //history.pushState('', document.title, window.location.pathname);
            $('html, body').animate({
                scrollTop: $target.offset().top
            }, 800);
        }
    });

})(jQuery);